import * as actionTypes from './actionTypes';

export const setUnreadCount = (source, count) => ({
    type: actionTypes.UNREAD_COUNT_SET,
    source,
    count,
});
